import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import  Axios  from "../../utils/axios"

export const reqToFetchDistributerStates = createAsyncThunk("distribution/reqToFetchDistributerStates", async ({rejectWithValue}) => {
    try{
      const response = await Axios.get(`/api/distributor-states`);
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const distributorCities = createAsyncThunk("distribution/distributorCities", async (data,{rejectWithValue}) => {
    try{
      const response = await Axios.post(`/api/distributor-cities`,data);
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});

export const distributerList = createAsyncThunk("distribution/distributerList", async ({search, state_id, city_id},{rejectWithValue}) => {
    try{
      const response = await Axios.get(`/api/distributors-state-city-wise`,{ params: {search, state_id, city_id}});
      return response.data;
    }catch(error){
      return rejectWithValue(error.response.data);
    }
});



const distributionSlice = createSlice({
    name:"distribution",
    initialState:{
        error:null,
        isLoading:false,
        states:[],
        city:[],
        list:[]
    },
    reducer:{},
    extraReducers:(builder)=>{
        builder
        // Req to Get List of Distributer LIst
        .addCase(distributerList.fulfilled, (state,action) => {
            state.isLoading = false;
            state.list = action.payload
        })
        // Req to Get List of Distributer Cities
        .addCase(distributorCities.fulfilled, (state,action) => {
            state.isLoading = false;
            state.city = action.payload
        })
         // Req to Get List of Distributer States
        .addCase(reqToFetchDistributerStates.fulfilled, (state,action) => {
            state.isLoading = false;
            state.states = action.payload
        })
    }
})

export default distributionSlice.reducer;